module.exports = __webpack_public_path__ + "static/media/nn-Nonord-Y-A-trial-Skjofenal.b1c0ea26.mp3";